import communityapi from "./apiClient";
 
// GET posts by kalp category
export const getPosts = async (category) => {
  const res = await communityapi.get(`/api/posts?category=${category}`);
  return res.data;
};

// CREATE post
export const createPost = async (formData) => {

  const res = await communityapi.post(
    "/api/posts",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};

export const uploadImage = async (file) => {

  const formData = new FormData();

  formData.append("file", file);

  const res = await communityapi.post(
    "/api/upload",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};